export const getPlatbandPoints = function (sourcePoints, multiplier) {

    let planeSumX = 0;
    let planeSumY = 0;
    let platbandSumX = 0;
    let platbandSumY = 0;
    let platbandPoints = [];
    for (let pointID in sourcePoints) {
        let planePoint = sourcePoints[pointID];
        let point={
            link: planePoint.link,
            x: planePoint.x*multiplier,
            y: planePoint.y*multiplier,
        };
        platbandPoints.push(point);
        planeSumX += planePoint.x;
        planeSumY += planePoint.y;
        platbandSumX += point.x;
        platbandSumY += point.y;
    }
    let pointsNum = platbandPoints.length;
    let planeMiddlePoint = {
        x: planeSumX / pointsNum,
        y: planeSumY / pointsNum,
    }
    let platbandMiddlePoint = {
        x: platbandSumX / pointsNum,
        y: platbandSumY / pointsNum,
    }
    platbandPoints.forEach((point)=>{
        point.x-= (platbandMiddlePoint.x - planeMiddlePoint.x);
        point.y-= (platbandMiddlePoint.y - planeMiddlePoint.y);
    })

    return platbandPoints;
}
